export const getTutorialImageUrl = (
  tutorialName: string,
  stepName: string,
  localeCode?: string,
  extension = 'png',
): string => {
  //Tutorial assets needs to be changed too?
  return `https://storage.googleapis.com/favur-tutorial-assets/${tutorialName}/${stepName}_${localeCode}.${extension}`
}
